module.exports = __webpack_public_path__ + "static/media/3동물권-1마을소개.2ee2de4b.mp3";